import { html, i18nKeys, t } from "../i18n/i18n";
import { getContactUsLink } from "../helpers";

export enum LoginServiceErrorCode {
  INVALID_CREDENTIALS,
  UNKNOWN_RESPONSE,
  REQUEST_FAILED,
  WEAK_PASSWORD,
  TOU_NOT_AGREED,
  EMAIL_IS_EMPTY,
  TOO_MANY_ATTEMPTS,
  TOU_DATE_MISMATCH,
  UNAUTHORIZED
}

type LoginServiceErrorData = {
  // comes with TOO_MANY_ATTEMPTS error
  retryAfter: number;
};

export class LoginServiceError extends Error {
  constructor(
    public code: LoginServiceErrorCode,
    public data?: LoginServiceErrorData
  ) {
    super(code.toString());
  }
}

export const getUnknownErrorSubtitle = () => {
  return html(
    t(i18nKeys.unknownErrorSubTitle1) +
      getContactUsLink(t(i18nKeys.unknownErrorSubTitle2)) +
      t(i18nKeys.unknownErrorSubTitle3)
  );
};

export function getErrorMessage(error: LoginServiceError) {
  let title, subTitle;
  switch (error.code) {
    case LoginServiceErrorCode.INVALID_CREDENTIALS:
      title = t(i18nKeys.invalidCredentialsErrorTitle);
      subTitle = t(i18nKeys.invalidCredentialsErrorSubtitle);
      break;
    case LoginServiceErrorCode.EMAIL_IS_EMPTY:
      title = t(i18nKeys.emailRequired);
      break;
    case LoginServiceErrorCode.WEAK_PASSWORD:
      title = t(i18nKeys.weakPassword);
      break;
    case LoginServiceErrorCode.TOO_MANY_ATTEMPTS:
      title = t(i18nKeys.tooManyAttemptsTitle);
      subTitle = t(i18nKeys.tooManyAttemptsSubtitle);
      break;
    default:
      title = t(i18nKeys.unknownError);
      subTitle = getUnknownErrorSubtitle();
  }
  return { title, subTitle };
}
